import { render, staticRenderFns } from "./sorting.vue?vue&type=template&id=f6a9d10a&"
import script from "./sorting.vue?vue&type=script&lang=ts&"
export * from "./sorting.vue?vue&type=script&lang=ts&"
import style0 from "./sorting.vue?vue&type=style&index=0&id=f6a9d10a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports